import classNames from 'classnames/bind';
import { bool, func, string } from 'prop-types';
import React, { forwardRef, useEffect, useRef, useState } from 'react';

import { Button } from '../../atom/Button';
import Input from '../../molecule/Input';

import style from './PromoCode.module.scss';

const cx = classNames.bind(style);

const PromoCode = forwardRef(
  (
    {
      className,
      applyText,
      buttonText,
      labelText,
      confirmationText,
      error,
      onSubmit,
      showConfirmation,
      location,
      disabled,
      validPromoCode,
      promoCodeText,
      ...rest
    },
    ref,
  ) => {
    const formRef = useRef();
    const [isPromoOpen, setIsPromoOpen] = useState(validPromoCode);

    const handleOpen = () => {
      const formElement = formRef.current;
      if (formElement) {
        setIsPromoOpen(true);
      }
    };

    useEffect(() => {
      const formElement = formRef.current;

      if (formElement && !isPromoOpen) {
        setIsPromoOpen(false);
      }
    }, [location]);

    return (
      <div className={cx('promo-code', className)}>
        <Button
          title="promotion"
          className={`btn-prompt ${cx(
            'promo-code__btn-prompt',
            !isPromoOpen ? 'show' : 'hide',
          )}`}
          onClick={handleOpen}
          qaTag="promo-code-cta"
        >
          {buttonText}
        </Button>
        <form
          className={cx('promo-code__form', isPromoOpen ? 'show' : 'hide')}
          ref={formRef}
          data-qa="promo-code-form"
          onSubmit={onSubmit}
        >
          <Input
            id="promo-code"
            dataTestId="promo-code"
            name="promo-code"
            labelCopy={labelText}
            type="text"
            variant="promo-code"
            error={error}
            errorType="promo-error"
            ref={ref}
            {...rest}
          />
          <Button
            title="promo-code"
            className={cx('promo-code__btn-add')}
            qaTag="promo-code-add-btn"
            type="submit"
            disabled={disabled}
          >
            {applyText}
          </Button>
          <div
            className={cx('promo-code__tag', {
              hide: !validPromoCode,
            })}
            data-qa="promo-code-text"
          >
            <p className={cx('promo-code__text')} data-qa="promo-code-tag-text">
              {promoCodeText}
            </p>
          </div>

          <div
            className={`confirmation ${cx(
              'promo-code__confirmation',
              showConfirmation ? 'show' : 'hide',
            )}`}
            data-qa="promo-code-confirmation"
          >
            <span>{confirmationText}</span>
          </div>
        </form>
      </div>
    );
  },
);

PromoCode.defaultProps = {
  className: '',
  confirmationText: '',
  promoCodeText: '',
  showConfirmation: false,
  validPromoCode: false,
  error: null,
  location: '',
  disabled: false,
};

PromoCode.propTypes = {
  className: string,
  applyText: string.isRequired,
  buttonText: string.isRequired,
  labelText: string.isRequired,
  confirmationText: string,
  error: string,
  onSubmit: func.isRequired,
  showConfirmation: bool,
  validPromoCode: bool,
  promoCodeText: string,
  location: string,
  disabled: bool,
};

export default PromoCode;
